import { render, staticRenderFns } from "./TermsCondWappinNew.vue?vue&type=template&id=08b707f4&"
import script from "./TermsCondWappinNew.vue?vue&type=script&lang=js&"
export * from "./TermsCondWappinNew.vue?vue&type=script&lang=js&"
import style0 from "./TermsCondWappinNew.vue?vue&type=style&index=0&id=08b707f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports